'use strict';

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.bind");

module.exports = function (template, args) {
  if (!args) {
    return interpolate.bind(null, template);
  }

  return interpolate(template, args);
};

function interpolate(template, args) {
  if (typeof args === 'undefined') {
    args = {};
  }

  return template.replace(/{([^}]*)}/g, function (match, key) {
    return key in args ? args[key] : match;
  });
}